import React, { useState } from 'react'
import {
  Button,
  Select,
  Collapse,
  Form,
  message,
  Tabs,
  Popover,
  DatePicker,
  Radio,
  InputNumber
} from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { CalendarOutlined } from '@ant-design/icons'
import {
  loadSpecifiedDateRangeData,
  calculateComparisonDate
} from '../../appRedux/actions/Reports'
import IntlMessages from '../../util/IntlMessages'
import moment from 'moment'
import { isEmptyObject } from '../../appRedux/actions'

const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const RadioGroup = Radio.Group
const SpecifiedDateRange = props => {
  const tabs = props.tabs ? props.tabs : ''
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  //#region useState
  const [getActiveTab, setActiveTab] = useState(
    tabs && tabs.toLowerCase() == 'DateRange_OnlySpecifiedDates'.toLowerCase()
      ? '2'
      : '1'
  ) //SpecifyPeriodActiveTab
  const [getPeriodValue, setPeriodValue] = useState('firstofweek')
  const [getPeriodTypeValue, setPeriodTypeValue] = React.useState(3) //Its mean - Last Week 4 weeks Radio Selection
  const [getDateToValue, setDateToValue] = useState('4') //Input field value of Last {4} years,Last {4} Quarters etc
  const [getDateFromValue, setDateFromValue] = useState('') //DatePicker value of -- years from {2021} ,quarters from {2021-Q1}tc
  const [getDateRangeJson, setDateRangeJson] = useState({})
  const [getIsDateRangePopoverVisible, setIsDateRangePopoverVisible] =
    useState(false)
  const [getDateFromToObj, setDateFromToObj] = useState({})
  const [getDisplayDate, setDisplayDate] = useState('')
  const [isShowPeriod, setIsShowPeriod] = useState(false)
  const [rangeError, setRangeError] = useState(false)
  //#endregion useState

  //#region Use Selector Start Region
  const getReduxSpecifiedDateRangeData = useSelector(
    ({ Reports }) => Reports.specifiedDateRangeData
  )

  //#region for Use Effect Start Region
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      //salis
      const urlObj = checkUrlSession()
      if (urlObj.res) {
        let selectedToDate = urlObj.jsonObj.DateTimeTo
        let periodID = urlObj.jsonObj.PeriodId

        let periodValue = 'firstofweek'
        let periodTypeValue = 1
        let pDateToValue = 1
        if (periodID == 26) {
          periodValue = 'month'
        }
        if (periodID == 29) {
          periodValue = 'date'
        }
        if (periodID == 32) {
          periodValue = 'firstofweek'
        }
        setPeriodValue(periodValue)
        setDateToValue(1) //Week Count, Month Count , Day Count
        setPeriodTypeValue(1) //Week To Date, Month To Date , Day To Date

        CalculateDateRange(
          getActiveTab,
          periodValue,
          periodTypeValue,
          pDateToValue,
          '',
          '',
          true,
          selectedToDate
        )
      } else {
        CalculateDateRange(
          getActiveTab,
          getPeriodValue,
          getPeriodTypeValue,
          getDateToValue,
          getDateFromValue,
          '',
          true
        )
      }
      return () => (mounted = false)
      // //;
    }
  }, [])

  //how to use
  React.useEffect(() => {
    let mounted = true

    if (mounted) {
      let jsonData = getReduxSpecifiedDateRangeData
      let displayDate =
        getReduxSpecifiedDateRangeData &&
        getReduxSpecifiedDateRangeData != undefined
          ? getReduxSpecifiedDateRangeData.IsSpecificPeriod == true
            ? getReduxSpecifiedDateRangeData.SpecificPeriodDates &&
              getReduxSpecifiedDateRangeData.SpecificPeriodDates.DisplayDate &&
              getReduxSpecifiedDateRangeData.SpecificPeriodDates.DisplayDate !=
                ''
              ? getReduxSpecifiedDateRangeData.SpecificPeriodDates.DisplayDate
              : ''
            : getReduxSpecifiedDateRangeData.SpecificDatesRange &&
              getReduxSpecifiedDateRangeData.SpecificDatesRange.DisplayDate &&
              getReduxSpecifiedDateRangeData.SpecificDatesRange.DisplayDate !=
                ''
            ? getReduxSpecifiedDateRangeData.SpecificPeriodDates.DisplayDate
            : ''
          : ''
      setDisplayDate(displayDate)
      return () => (mounted = false)
    }
  }, [getReduxSpecifiedDateRangeData])
  //#endregion for Use Effect End Region

  //#region onChange Functions
  function checkUrlSession () {
    //salis
    let obj = {
      res: false,
      jsonObj: {}
    }

    const params = new URLSearchParams(window.location.search)
    const queryParam = params.get('definition')
    let jsonObj = JSON.parse(queryParam)
    if (jsonObj && !isEmptyObject(jsonObj)) {
      obj.res = true
      obj.jsonObj = jsonObj
    }
    return obj
  }

  const handleChangeSpecifyTab = e => {
    if (e && e == '2') {
      setIsShowPeriod(true)
    } else {
      setIsShowPeriod(false)
    }
    setActiveTab(e)
    let activeTab = e
    CalculateDateRange(
      activeTab,
      getPeriodValue,
      getPeriodTypeValue,
      getDateToValue,
      getDateFromValue
    )
  }
  const handleChangeRadioPeriod = e => {
    setPeriodValue(e.target.value)
    let periodValue = e.target.value
    CalculateDateRange(
      getActiveTab,
      periodValue,
      getPeriodTypeValue,
      getDateToValue,
      getDateFromValue
    )
  }
  const handleChangeRadioPeriodType = e => {
    setPeriodTypeValue(e.target.value)
    let periodTypeValue = e.target.value
    CalculateDateRange(
      getActiveTab,
      getPeriodValue,
      periodTypeValue,
      getDateToValue,
      getDateFromValue
    )
  }

  const handleChangeInputDateToValue = e => {
    setDateToValue(e)
    let toValue = e
    CalculateDateRange(
      getActiveTab,
      getPeriodValue,
      getPeriodTypeValue,
      toValue,
      getDateFromValue
    )
  }
  function onChangeSpecifyPeriodPicker (date, dateString) {
    let dateFromValue = {
      dateObj: date,
      dateString: dateString
    }

    setDateFromValue(dateFromValue)
    CalculateDateRange(
      getActiveTab,
      getPeriodValue,
      getPeriodTypeValue,
      getDateToValue,
      dateFromValue
    )
  }

  function onChangeSpecifyDatePicker (dates, dateStrings) {
    let dateFromToObj = {
      dateFromObj: dates[0],
      dateFromValue: dateStrings[0],
      dateToObj: dates[1],
      dateToValue: dateStrings[1]
    }

    setDateFromToObj(dateFromToObj)
    CalculateDateRange(
      getActiveTab,
      getPeriodValue,
      getPeriodTypeValue,
      getDateToValue,
      getDateFromValue,
      dateFromToObj
    )
  }
  const handleClickDateApply = () => {
    setIsDateRangePopoverVisible(false)
    dispatch(loadSpecifiedDateRangeData(getDateRangeJson))
    //set redux value here
  }

  //#endregion onChange Functions

  //#region Calculated Functions

  function disabledDate (current) {
    // Can not select days before today and today
    return current && current > moment().endOf('day')
  }

  //p for props propsActiveTabv
  const CalculateDateRange = (
    pActiveTab,
    pPeriodValue,
    pPeriodTypeValue,
    pDateToValue,
    pDateFromValue,
    pDateFromToObj,
    isRedux,
    pSelectedToDate
  ) => {
    setRangeError(false)
    //salis
    let activeSpecifyTab = pActiveTab
    let periodValue = pPeriodValue // 1.year 2.quarter 3.month 4.week 5.day 6.hpur
    let periodTypeValue = pPeriodTypeValue // 1.week-to-date,2.previousweek,3.last4weeks,etc...
    let toValue = pDateToValue
    let fromValue = pDateFromValue
    let periodKey = ''
    let fromDate = '' //"01/01/2021"
    let toDate = '' //"17/11/2021"
    let dateFormat = ''
    let displayDate =
      moment().startOf('year').format('Do/MMM/YYYY') +
      ' to ' +
      moment().format('Do/MMM/YYYY') //  "1st Jan 2021–17th Nov 2021";
    let dateFromToObj = pDateFromToObj
    let isReduxSet = isRedux != undefined ? isRedux : false
    //activeSpecifyTab --> 1. Specific Period, 2. Specify Dates
    if (activeSpecifyTab == '1') {
      if (periodValue === 'year') {
        //1.Year to Date, 2.Previous Year, 3.Last 4 Years,4. 4 years from 2021
        periodKey = 1
        if (periodTypeValue == 1) {
          toDate = moment().format('YYYY-MM-DD')
          fromDate = moment().startOf('year').format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 2) {
          toDate = moment()
            .subtract(1, 'year')
            .endOf('year')
            .format('YYYY-MM-DD')
          fromDate = moment()
            .subtract(1, 'year')
            .startOf('year')
            .format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 3) {
          let totalMonth = toValue * 12
          if (totalMonth <= 25) {
            toDate = moment().format('YYYY-MM-DD')
            fromDate = moment()
              .subtract(toValue - 1, 'year')
              .startOf('year')
              .format('YYYY-MM-DD')
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalMonth = toValue * 12
          if (totalMonth <= 25) {
            // 2 years from 2017
            // 1 jan 2017 - 31 Dec 2018
            let fromYear =
              fromValue.dateString != undefined
                ? fromValue.dateString
                : moment(moment(), 'YYYY')
            fromDate = moment(moment(fromYear), 'YYYY')
              .startOf('year')
              .format('YYYY-MM-DD')
            toDate = moment(moment(fromYear), 'YYYY')
              .add(toValue - 1, 'year')
              .endOf('year')
              .format('YYYY-MM-DD')
            //   toDate = moment().subtract(toValue-1, 'year').endOf("year").format("YYYY-MM-DD")  ;
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
      if (periodValue === 'quarter') {
        //1.Quarter to Date, 2.Previous Quarter, 3.Last 4 Quarter,4. 4 Quarter from 2021
        periodKey = 2
        if (periodTypeValue == 1) {
          toDate = moment().format('YYYY-MM-DD')
          fromDate = moment().startOf('quarter').format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }

        if (periodTypeValue == 2) {
          toDate = moment()
            .subtract(1, 'quarter')
            .endOf('quarter')
            .format('YYYY-MM-DD')
          fromDate = moment()
            .subtract(1, 'quarter')
            .startOf('quarter')
            .format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 3) {
          let totalMonth = (toValue / 4) * 12
          if (totalMonth <= 25) {
            toDate = moment().format('YYYY-MM-DD')
            fromDate = moment()
              .subtract(toValue - 1, 'quarter')
              .startOf('quarter')
              .format('YYYY-MM-DD')
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalMonth = (toValue / 4) * 12
          if (totalMonth <= 25) {
            // 2 years from 2017
            // 1 jan 2017 - 31 Dec 2018
            let fromQuarterYear =
              fromValue.dateString != undefined
                ? moment(moment(fromValue.dateObj), 'YYYY-Q')
                : moment(moment(), 'YYYY-Q')
            fromDate = moment(moment(fromQuarterYear), 'YYYY-Q')
              .startOf('quarter')
              .format('YYYY-MM-DD')
            toDate = moment(moment(fromQuarterYear), 'YYYY-Q')
              .add(toValue - 1, 'quarter')
              .endOf('quarter')
              .format('YYYY-MM-DD')
            //   toDate = moment().subtract(toValue-1, 'year').endOf("year").format("YYYY-MM-DD")  ;
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
      if (periodValue === 'month') {
        //1.Month to Date, 2.Previous Month, 3.Last 4 Month,4. 4 Month from 2021
        periodKey = 3
        if (periodTypeValue == 1) {
          toDate = moment(pSelectedToDate).format('YYYY-MM-DD')
          fromDate = moment(toDate).startOf('month').format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 2) {
          toDate = moment()
            .subtract(1, 'month')
            .endOf('month')
            .format('YYYY-MM-DD')
          fromDate = moment()
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 3) {
          let totalMonth = toValue
          if (totalMonth <= 25) {
            toDate = moment().format('YYYY-MM-DD')
            fromDate = moment()
              .subtract(toValue - 1, 'month')
              .startOf('month')
              .format('YYYY-MM-DD')
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              '-' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalMonth = toValue
          if (totalMonth <= 25) {
            // 2 years from 2017
            // 1 jan 2017 - 31 Dec 2018
            let fromMonth =
              fromValue.dateString != undefined
                ? moment(moment(fromValue.dateObj), 'MM/YYYY')
                : moment(moment(), 'MM/YYYY')
            fromDate = moment(moment(fromMonth), 'MM/YYYY')
              .startOf('month')
              .format('YYYY-MM-DD')
            toDate = moment(moment(fromMonth), 'MM/YYYY')
              .add(toValue - 1, 'month')
              .endOf('month')
              .format('YYYY-MM-DD')
            //   toDate = moment().subtract(toValue-1, 'year').endOf("year").format("YYYY-MM-DD")  ;
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              '-' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
      if (periodValue === 'firstofweek') {
        periodKey = 4
        if (periodTypeValue == 1) {
          toDate = moment(pSelectedToDate).format('YYYY-MM-DD')
          fromDate = moment(toDate).startOf('isoWeek').format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            '-' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 2) {
          toDate = moment()
            .subtract(1, 'week')
            .endOf('isoWeek')
            .format('YYYY-MM-DD')
          fromDate = moment()
            .subtract(1, 'week')
            .startOf('isoWeek')
            .format('YYYY-MM-DD')
          dateFormat = 'YYYY-MM-DD'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
            '-' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 3) {
          let totalWeek = toValue
          if (totalWeek <= 106) {
            toDate = moment().format('YYYY-MM-DD')
            fromDate = moment()
              .subtract(toValue - 1, 'week')
              .startOf('isoWeek')
              .format('YYYY-MM-DD')
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalWeek = toValue
          //106 weeks in two year
          if (totalWeek <= 106) {
            let fromWeek =
              fromValue.dateString != undefined
                ? moment(moment(fromValue.dateObj), 'YYYY-MM-DD')
                : moment(moment(), 'YYYY-MM-DD')
            fromDate = moment(moment(fromWeek), 'YYYY-MM-DD')
              .startOf('isoWeek')
              .format('YYYY-MM-DD')
            toDate = moment(moment(fromWeek), 'YYYY-MM-DD')
              .add(toValue - 1, 'week')
              .endOf('isoWeek')
              .format('YYYY-MM-DD')
            //   toDate = moment().subtract(toValue-1, 'year').endOf("year").format("YYYY-MM-DD")  ;
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
      if (periodValue === 'date') {
        periodKey = 5
        if (periodTypeValue == 1) {
          toDate = moment(pSelectedToDate)
            .endOf('day')
            .format('YYYY-MM-DDTHH:mm:ss')
          fromDate = moment(toDate).format('YYYY-MM-DD')

          dateFormat = 'YYYY-MM-DD'
          displayDate = moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 2) {
          fromDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
          toDate = moment()
            .subtract(1, 'day')
            .endOf('day')
            .format('YYYY-MM-DDTHH:mm:ss')
          dateFormat = 'YYYY-MM-DD'
          displayDate = moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
        }
        if (periodTypeValue == 3) {
          let totalDays = toValue
          //741 Days in two year
          if (totalDays <= 741) {
            toDate = moment().format('YYYY-MM-DD')
            fromDate = moment()
              .subtract(toValue - 1, 'day')
              .format('YYYY-MM-DD')
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalDays = toValue
          //741 Days in two year
          if (totalDays <= 741) {
            let fromDay =
              fromValue.dateString != undefined
                ? moment(moment(fromValue.dateObj), 'YYYY-MM-DD')
                : moment(moment(), 'YYYY-MM-DD')
            fromDate = moment(moment(fromDay), 'YYYY-MM-DD')
              .startOf('day')
              .format('YYYY-MM-DD')
            toDate = moment(moment(fromDay), 'YYYY-MM-DD')
              .add(toValue - 1, 'day')
              .endOf('day')
              .format('YYYY-MM-DD')
            //   toDate = moment().subtract(toValue-1, 'year').endOf("year").format("YYYY-MM-DD")  ;
            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
      if (periodValue === 'time') {
        periodKey = 6
        if (periodTypeValue == 1) {
          toDate = moment(moment(), 'DD MM YYYY hh:mm:ss A') //moment().format("YYYY-MM-DD hh:mm A");
          fromDate = moment(moment().startOf('hour'), 'DD MM YYYY hh:mm:ss A') //moment().startOf("day").format("YYYY-MM-DD");
          dateFormat = 'YYYY-MM-DD hh:mm:ss A'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD ').format('YYYY-MM-DD hh:mm A') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD hh:mm A')
        }
        if (periodTypeValue == 2) {
          toDate = moment(
            moment().subtract(1, 'hour').endOf('hour'),
            'DD MM YYYY hh:mm:ss A'
          ) //moment().format("YYYY-MM-DD hh:mm A");
          fromDate = moment(
            moment().subtract(1, 'hour').startOf('hour'),
            'DD MM YYYY hh:mm:ss A'
          ) //moment().startOf("day").format("YYYY-MM-DD");
          dateFormat = 'YYYY-MM-DD hh:mm:ss A'
          displayDate =
            moment(fromDate, 'YYYY-MM-DD ').format('YYYY-MM-DD hh:mm A') +
            ' to ' +
            moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD hh:mm A')
        }
        if (periodTypeValue == 3) {
          let totalHours = toValue
          // 17784 Hours in 2 years
          if (totalHours <= 17784) {
            toDate = moment(moment().endOf('hour'), 'DD MM YYYY hh:mm:ss A') //moment().format("YYYY-MM-DD hh:mm A");
            // fromDate = fromValue.dateObj;
            fromDate = moment(
              moment()
                .subtract(toValue - 1, 'hour')
                .startOf('hour'),
              'DD MM YYYY hh:mm:ss A'
            ) //moment().startOf("day").format("YYYY-MM-DD");
            dateFormat = 'YYYY-MM-DD hh:mm:ss A'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD ').format('YYYY-MM-DD hh:mm A') +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD hh:mm A')
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
        if (periodTypeValue == 4) {
          let totalHours = toValue
          // 17784 Hours in 2 years
          if (totalHours <= 17784) {
            // fromDate = moment(moment().endOf("hour"), "DD MM YYYY hh:mm:ss A"); //moment().format("YYYY-MM-DD hh:mm A");
            // toDate = moment(
            //   moment()
            //     .subtract(toValue - 1, "hour")
            //     .startOf("hour"),
            //   "DD MM YYYY hh:mm:ss A"
            // ); //moment().startOf("day").format("YYYY-MM-DD");
            // dateFormat = "YYYY-MM-DD hh:mm:ss A";
            // displayDate =
            //   moment(toDate, "YYYY-MM-DD ").format("YYYY-MM-DD hh:mm A") +
            //   "-" +
            //   moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD hh:mm A");

            let fromHour =
              fromValue.dateObj != undefined
                ? moment(moment(fromValue.dateObj), 'YYYY-MM-DD hh:mm:ss A')
                : moment(moment(), 'YYYY-MM-DD hh:mm:ss A')
            fromDate = moment(moment(fromHour), 'YYYY-MM-DD hh:mm:ss A').format(
              'YYYY-MM-DD  hh:mm:ss A'
            )

            toDate = moment(moment(fromHour), 'YYYY-MM-DD hh:mm:ss A')
              .add(toValue, 'hour')
              .format('YYYY-MM-DD  hh:mm:ss A')
            // toDate = moment(moment(fromHour), "YYYY-MM-DD hh:mm:ss A")
            //   .add(toValue - 1, "hour")
            //   .format("YYYY-MM-DD  hh:mm:ss A");

            dateFormat = 'YYYY-MM-DD'
            displayDate =
              moment(fromDate, 'YYYY-MM-DD hh:mm A').format(
                'YYYY-MM-DD hh:mm:ss A'
              ) +
              ' to ' +
              moment(toDate, 'YYYY-MM-DD hh:mm A').format(
                'YYYY-MM-DD hh:mm:ss A'
              )
          } else {
            setRangeError(true)
            message.warn(
              'Please choose a date range that isn’t wider than 25 months'
            )
            let messageValue =
              'Please choose a date range that isn’t wider than 25 months'
          }
        }
      }
    } else {
      fromDate =
        dateFromToObj &&
        dateFromToObj != '' &&
        dateFromToObj.dateFromObj != undefined
          ? moment(moment(dateFromToObj.dateFromObj), 'YYYY-MM-DD').format(
              'YYYY-MM-DD'
            )
          : moment(moment(), 'YYYY-MM-DD')
              .startOf('isoWeek')
              .format('YYYY-MM-DD')
      toDate =
        dateFromToObj && dateFromToObj.dateToObj != undefined
          ? moment(moment(dateFromToObj.dateToObj), 'YYYY-MM-DD').format(
              'YYYY-MM-DD'
            )
          : moment(moment(), 'YYYY-MM-DD').format('YYYY-MM-DD')
      // fromDate =
      //   dateFromToObj &&
      //     dateFromToObj != "" &&
      //     dateFromToObj.dateFromObj != undefined
      //     ? moment(moment(dateFromToObj.dateFromObj), "YYYY-MM-DD")
      //       .startOf("isoWeek")
      //       .format("YYYY-MM-DD")
      //     : moment(moment(), "YYYY-MM-DD")
      //       .startOf("isoWeek")
      //       .format("YYYY-MM-DD");
      // toDate =
      //   dateFromToObj && dateFromToObj.dateFromObj != undefined
      //     ? moment(moment(dateFromToObj.dateFromObj), "YYYY-MM-DD").format(
      //       "YYYY-MM-DD"
      //     )
      //     : moment(moment(), "YYYY-MM-DD").format("YYYY-MM-DD");
      dateFormat = 'YYYY-MM-DD'
      displayDate =
        moment(fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') +
        ' to ' +
        moment(toDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
    }
    // 2022-08-15T16:00:00
    const DateRangeJson = {
      IsSpecificPeriod: activeSpecifyTab == '1' ? true : false,
      SpecificPeriodDates: {
        PeriodKey: periodKey,
        FromDate: moment(fromDate).format('YYYY-MM-DDTHH:mm:00'),
        ToDate: moment(toDate).format('YYYY-MM-DDTHH:mm:00'),
        DateFormat: dateFormat,
        Period: periodValue,
        PeriodType: {
          periodTypeKey: periodTypeValue, // TypeValue: 1."yeartodate", 2.Previousyear ,3.Last 4 years respectively of all others period value
          ToValue: toValue,
          FromValueDateObject: fromValue //
        },
        DisplayDate: displayDate
      },
      SpecificDatesRange: {
        FromDate: moment(fromDate).format('YYYY-MM-DDTHH:mm:00'),
        ToDate: moment(moment(toDate))
          .endOf('day')
          .format('YYYY-MM-DDTHH:mm:00'),
        DateFromat: '',
        DisplayDate: displayDate
      }
    }

    setDateRangeJson(DateRangeJson)
    calculateComparisonDate(DateRangeJson, dispatch)
    dispatch(loadSpecifiedDateRangeData(DateRangeJson))
    // if (isReduxSet) {
    //   dispatch(loadSpecifiedDateRangeData(DateRangeJson));
    // }
  }
  //#endregion

  const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px'
  }

  const PickerWithType = () => {
    // { type, onChange }
    const type = getPeriodValue
    if (type === 'year') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.yeartodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previosyear' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.years' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.years' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            <DatePicker
              inputReadOnly
              picker='year'
              disabledDate={disabledDate}
              value={moment(
                getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'YYYY'
              )}
              onChange={onChangeSpecifyPeriodPicker}
            />
          </Radio>
        </RadioGroup>
      )
    }
    if (type === 'quarter') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.quartertodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previousquarter' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
              value={getDateToValue}
            />{' '}
            <IntlMessages id='components.reporting.quarter' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
              value={getDateToValue}
            />{' '}
            <IntlMessages id='components.reporting.quarters' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            <DatePicker
              inputReadOnly
              picker='quarter'
              value={moment(
                getDateFromValue.dateString &&
                  getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'YYYY-Q'
              )}
              onChange={onChangeSpecifyPeriodPicker}
            />
          </Radio>
        </RadioGroup>
      )
    }
    if (type === 'month') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.monthtodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previousmonth' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.months' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.months' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            <DatePicker
              inputReadOnly
              picker='month'
              value={moment(
                getDateFromValue.dateString &&
                  getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'YYYY/MMMM'
              )}
              format={'YYYY-MMM'}
              onChange={onChangeSpecifyPeriodPicker}
            />
          </Radio>
        </RadioGroup>
      )
    }
    if (type === 'firstofweek') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.weektodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previousweek' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
              type='number'
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.weeks' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.weeks' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            <DatePicker
              inputReadOnly
              onChange={onChangeSpecifyPeriodPicker}
              picker='month'
              value={moment(
                getDateFromValue.dateString &&
                  getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'DD/MMM/YYYY'
              )}
              format={'DD MMM YYYY'}
            />
          </Radio>
        </RadioGroup>
      )
    }
    if (type === 'date') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.daytodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previousday' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.days' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.days' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            <DatePicker
              inputReadOnly
              onChange={onChangeSpecifyPeriodPicker}
              value={moment(
                getDateFromValue.dateString &&
                  getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'DD/MMM/YYYY'
              )}
              format={'DD MMM YYYY'}
            />
          </Radio>
        </RadioGroup>
      )
    }
    if (type === 'time') {
      return (
        <RadioGroup
          className='label-list'
          onChange={e => {
            handleChangeRadioPeriodType(e)
          }}
          checked={true}
          value={getPeriodTypeValue}
        >
          <Radio style={radioStyle} value={1}>
            <IntlMessages id='components.reporting.hourtodate' />
          </Radio>
          <Radio style={radioStyle} value={2}>
            <IntlMessages id='components.reporting.previouhour' />
          </Radio>
          <Radio style={radioStyle} value={3}>
            <IntlMessages id='components.reporting.last' />{' '}
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              value={getDateToValue}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
            />{' '}
            <IntlMessages id='components.reporting.hours' />{' '}
          </Radio>
          <Radio
            style={radioStyle}
            value={4}
            className='custom-mg-top-10 datepick-adj-md'
          >
            <InputNumber
            type="number"
              style={{ width: 100, marginLeft: 10 }}
              onChange={e => {
                handleChangeInputDateToValue(e)
              }}
              value={getDateToValue}
            />{' '}
            <IntlMessages id='components.reporting.hours' />,{' '}
            <IntlMessages id='components.reporting.from' />{' '}
            {/* onChange={onChange} onOk={onOk} */}
            <DatePicker
              inputReadOnly
              showTime
              onChange={onChangeSpecifyPeriodPicker}
              value={moment(
                getDateFromValue.dateString &&
                  getDateFromValue.dateString != undefined
                  ? getDateFromValue.dateString
                  : moment(),
                'DD/MMM/YYYY hh:mm A'
              )}
              format={'DD MMM YYYY hh:mm A'}
            />
          </Radio>
        </RadioGroup>
      )
    }
    // return <DatePicker picker={type} onChange={onChange} />;
  }
  const specifyPeriodOptions = [
    { label: 'Year', value: 'year' },
    { label: 'Quarter', value: 'quarter' },
    { label: 'Month', value: 'month' },
    { label: 'Week', value: 'firstofweek' },
    { label: 'Date', value: 'date' },
    { label: 'Hour', value: 'time' }
  ]

  const SwitchablePicker = () => {
    return (
      <>
        <Radio.Group
          options={specifyPeriodOptions}
          onChange={e => {
            handleChangeRadioPeriod(e)
          }}
          optionType='button'
          size='large'
          value={getPeriodValue}
        />
        <div>
          {PickerWithType()}
          {/* <PickerWithType
            type={getPeriodValue}
            onChange={(value) =>
               console.log(value)
              }
          /> */}
        </div>
      </>
    )
  }

  const dateRangeContent = (
    <>
      <Tabs
        defaultActiveKey={getActiveTab}
        onChange={e => {
          handleChangeSpecifyTab(e)
        }}
        size={'large'}
      >
        {tabs.toLowerCase() == 'daterange'.toLowerCase() ? (
          <>
            <TabPane
              tab={<IntlMessages id='components.reporting.specifyperiod' />}
              key={'1'}
            >
              {SwitchablePicker()}
            </TabPane>
            <TabPane
              tab={<IntlMessages id='components.reporting.specifydates' />}
              key={'2'}
            >
              <Form form={form} name='SpecifyDatesForm' scrollToFirstError>
                <Form.Item name={'From_To_Date'} className='dk-mg-lf-rt-0'>
                  <RangePicker
                    inputReadOnly
                    size={'large'}
                    onChange={onChangeSpecifyDatePicker}
                    defaultValue={[
                      moment(
                        getDateFromToObj.dateToValue != undefined
                          ? getDateFromToObj.dateToValue
                          : moment().startOf('isoWeek').format('YYYY-MM-DD'),
                        'YYYY-MM-DD'
                      ),
                      moment(
                        getDateFromToObj.dateFromValue != undefined
                          ? getDateFromToObj.dateFromValue
                          : moment(),
                        'YYYY-MM-DD'
                      )
                    ]}
                    format='YYYY-MM-DD'
                  />
                </Form.Item>
              </Form>
            </TabPane>
          </>
        ) : tabs.toLowerCase() ==
          'DateRange_AllTimeWithSpecifyDates'.toLowerCase() ? (
          <>
            <TabPane
              tab={<IntlMessages id='components.reporting.all' />}
              key={'1'}
            ></TabPane>
            <TabPane
              tab={<IntlMessages id='components.reporting.specifydates' />}
              key={'2'}
            >
              <Form form={form} name='SpecifyDatesForm' scrollToFirstError>
                <Form.Item name={'From_To_Date'} className='dk-mg-lf-rt-0'>
                  <RangePicker
                    inputReadOnly
                    size={'large'}
                    onChange={onChangeSpecifyDatePicker}
                    defaultValue={[
                      moment(
                        getDateFromToObj.dateToValue != undefined
                          ? getDateFromToObj.dateToValue
                          : moment().startOf('isoWeek').format('YYYY-MM-DD'),
                        'YYYY-MM-DD'
                      ),
                      moment(
                        getDateFromToObj.dateFromValue != undefined
                          ? getDateFromToObj.dateFromValue
                          : moment(),
                        'YYYY-MM-DD'
                      )
                    ]}
                    format='YYYY-MM-DD'
                  />
                </Form.Item>
              </Form>
            </TabPane>
          </>
        ) : tabs.toLowerCase() ==
          'DateRange_OnlySpecifiedDates'.toLowerCase() ? (
          <>
            <TabPane
              tab={<IntlMessages id='components.reporting.specifydates' />}
              key={'2'}
            >
              <Form form={form} name='SpecifyDatesForm' scrollToFirstError>
                <Form.Item name={'From_To_Date'} className='dk-mg-lf-rt-0'>
                  <RangePicker
                    inputReadOnly
                    size={'large'}
                    onChange={onChangeSpecifyDatePicker}
                    defaultValue={[
                      moment(
                        getDateFromToObj.dateToValue != undefined
                          ? getDateFromToObj.dateToValue
                          : moment().startOf('isoWeek').format('YYYY-MM-DD'),
                        'YYYY-MM-DD'
                      ),
                      moment(
                        getDateFromToObj.dateFromValue != undefined
                          ? getDateFromToObj.dateFromValue
                          : moment(),
                        'YYYY-MM-DD'
                      )
                    ]}
                    format='YYYY-MM-DD'
                  />
                </Form.Item>
              </Form>
            </TabPane>
          </>
        ) : (
          ''
        )}
      </Tabs>
      {isShowPeriod &&
        getDateRangeJson &&
        getDateRangeJson.SpecificPeriodDates &&
        getDateRangeJson.SpecificPeriodDates.Period && (
          <div>
            <IntlMessages id='common.resource.selectedrange' />
            <strong>
              {` "${getDateRangeJson.SpecificPeriodDates.Period.toLowerCase().replace(
                /\b(\w)/g,
                s => s.toUpperCase()
              )}"`}
              {/* {` "${getDateRangeJson.SpecificPeriodDates.Period}"`} */}
            </strong>
          </div>
        )}
      <div className='dk-specific-date dk-pt3 dk-pb3 custom-mg-top-10-i'>
        <span
          className={
            getPeriodValue == 'time'
              ? 'dk-speific-date-span-14f'
              : 'dk-speific-date-span-18f'
          }
        >
          {rangeError ? (
            <>
              <span>
                <p style={{ color: 'red', fontSize: 12 }}>
                  Please choose a date range that isn’t wider than 25 months
                </p>
              </span>
            </>
          ) : (
            <>
              {tabs.toLowerCase() ==
              'DateRange_AllTimeWithSpecifyDates'.toLowerCase() ? (
                <IntlMessages id='components.reporting.alltime' />
              ) : getDateRangeJson && getDateRangeJson.IsSpecificPeriod ? (
                getDateRangeJson.SpecificPeriodDates != undefined ? (
                  getDateRangeJson.SpecificPeriodDates.DisplayDate
                ) : (
                  ''
                )
              ) : getDateRangeJson.SpecificDatesRange != undefined ? (
                getDateRangeJson.SpecificDatesRange.DisplayDate
              ) : (
                ''
              )}
            </>
          )}
        </span>
        <Button
          className='mr-2'
          type='primary'
          onClick={() => handleClickDateApply()}
        >
          {' '}
          <IntlMessages id='components.reporting.apply' />
        </Button>
      </div>
    </>
  )

  return (
    <>
      <Popover
        placement='bottom'
        content={dateRangeContent}
        trigger='click'
        onVisibleChange={() => {
          setIsDateRangePopoverVisible(!getIsDateRangePopoverVisible)
        }}
        visible={getIsDateRangePopoverVisible}
      >
        <Form.Item
          className='ant-form-item-label-custom'
          name={'SpecifiedDateRange'}
          label={<IntlMessages id='components.reporting.daterange' />}
        >
          <Button
            size='large'
            className=''
            onClick={() => {
              setIsDateRangePopoverVisible(true)
            }}
            // style={{ width: "100%" }}
          >
            <div className='date-range-container'>
              <p className='custom-inline mb-0 date-range-p-md'>
                {getDisplayDate}
              </p>
              <CalendarOutlined className='dk-mg-left-10' />
            </div>
          </Button>
        </Form.Item>
      </Popover>
    </>
  )
}

export default SpecifiedDateRange
